import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Account from './components/Account';
import AdminDashboard from './components/AdminDashboard';
import CompleteSignup from './components/CompleteSignup';
import TrialSignupUserPassword from './components/TrialSignupUserPassword';
import ForgotPassword from './components/ForgotPassword';
import Login from './components/Login';
import ResetPassword from './components/ResetPassword';
import SetPassword from './components/SetPassword';
import SignupExistingUserStripe from './components/SignupExistingUserStripe';
import SignupWithInvite from './components/SignupWithInvite';
import SignupWithStripe from './components/SignupWithStripe';
import TrialSignup from './components/TrialSignup';
import TrialSignupLink from './components/TrialSignupLink';
import TrialSignupPayment from './components/TrialSignupPayment';
import { StripeElementsRoute } from './components/StripeElementsRoute';
import ProtectedRoute from './components/ProtectedRoute';
import TrialSignupSuccess from './components/TrialSignupSuccess';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
    return (
        <Router>
            <ScrollToTop />
            <div className='App min-h-screen flex flex-col'>
                <Routes>
                    <Route path='/login' element={<Login />} />
                    <Route path='/set-password' element={<SetPassword />} />
                    <Route path='/forgot-password' element={<ForgotPassword />} />
                    <Route path='/reset-password' element={<ResetPassword />} />
                    <Route path='/complete-signup' element={<CompleteSignup />} />
                    <Route path='/complete-email-signup' element={<TrialSignupUserPassword />} />
                    <Route path='/' element={<Navigate to='/login' replace />} />
                    <Route path='/trial-signup' element={<TrialSignup />} />
                    <Route path='/trial-signup-link' element={<TrialSignupLink />} />
                    <Route path='/trial-signup-success' element={<TrialSignupSuccess />} />
                    <Route path='/signup-invite' element={<SignupWithInvite />} />
                    {import.meta.env.VITE_STRIPE_SIGNUPS_ENABLED === 'true' ? (
                        <>
                            <Route
                                path='/signup-new'
                                element={
                                    <StripeElementsRoute>
                                        <SignupWithStripe />
                                    </StripeElementsRoute>
                                }
                            />
                            <Route
                                path='/signup-existing'
                                element={
                                    <StripeElementsRoute>
                                        <SignupExistingUserStripe />
                                    </StripeElementsRoute>
                                }
                            />
                            <Route
                                path='/trial-signup-payment'
                                element={
                                    <StripeElementsRoute>
                                        <TrialSignupPayment />
                                    </StripeElementsRoute>
                                }
                            />
                        </>
                    ) : null}
                    <Route path='/account' element={<Account />} />
                    <Route
                        path='/admin'
                        element={
                            <ProtectedRoute>
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route path='*' element={<Navigate to='/login' replace />} />
                </Routes>
                <Footer />
            </div>
        </Router>
    );
}

export default App;
